
exports.AreaChart = require('./AreaChart');



//////////////////
// WEBPACK FOOTER
// ./~/react-d3/areachart/index.js
// module id = 331
// module chunks = 0